module.exports = __webpack_public_path__ + "img/VIP1.16dbee67.png";